import { getMethod, postMethod } from '../../api/methods'
import API_ROUTES from '../../api/routes'
import { apiParams } from '../../utils'

const {
  DASHBOARD_SHIFT_REPORT,
  DASHBOARD_DISCREPANCIES,
  GET_DRINKING_WATER_BAR_CHART,
  GET_DRINKING_WATER_HOSTELS,
  GET_STAFF_AVAILABILITY_CHART,
  GET_STAFF_AVAILABILITY_HOSTELS,
  GET_AVAILABLE_TOILETS_CHART,
  GET_AVAILABLE_TOILETS_HOSTELS,
  DASHBOARD_PRINCIPAL_AUTHORITY_BAR_CHART,
  DASHBOARD_INSPECTION_ASSESSMENT_PIE_CHART,
  DASHBOARD_INSPECTION_ASSESSMENT_HOSTELS,
  DASHBOARD_PRINCIPAL_AUTHORITY_HOSTELS,
  DASHBOARD_RECORD_MAINTENANCE_BAR_CHART,
  DASHBOARD_OVERALL_HOSTEL_CONDITION_BAR_CHART,
  DASHBOARD_OVERALL_HOSTEL_CONDITION_HOSTELS,
  DASHBOARD_RECORD_MAINTENANCE_HOSTELS,
  DASHBOARD_WASTE_MANAGEMENT_BAR_CHART,
  DASHBOARD_WASTE_MANAGEMENT_HOSTELS,
  DASHBOARD_TOILETS_SUFFICIENCY_BAR_CHART,
  DASHBOARD_TOILETS_SUFFICIENCY_HOSTELS,
  DASHBOARD_LOCATION_BEDS_MATTRESSES_BAR_CHART,
  DASHBOARD_LOCATION_BEDS_MATTRESSES_HOSTELS,
  DASHBOARD_MEDICAL_CARE_BAR_CHART,
  DASHBOARD_MEDICAL_CARE_HOSTELS,
  DASHBOARD_EDUCATION_FACILITIES_BAR_CHART,
  DASHBOARD_EDUCATION_FACILITIES_HOSTELS,
  DASHBOARD_FOOD_PROVISIONS_BAR_CHART,
  DASHBOARD_FOOD_PROVISIONS_HOSTELS,
  DASHBOARD_PRECAUTIONARY_MEASURES_BAR_CHART,
  DASHBOARD_PRECAUTIONARY_MEASURES_HOSTELS,
  DASHBOARD_ANIMAL_THREAT_BAR_CHART,
  DASHBOARD_ANIMAL_THREAT_HOSTELS,
  DASHBOARD_CONDUCTION_MEETINGS_BAR_CHART,
  DASHBOARD_CONDUCTION_MEETINGS_HOSTELS,
  DASHBOARD_COOKING_FUEL_BAR_CHART,
  DASHBOARD_COOKING_FUEL_HOSTELS,
  GET_FUNCTIONING_TOILETS_CHART,
  GET_FUNCTIONING_TOILETS_HOSTELS,
  GET_HOSTEL_STUDENT_CHART,
  GET_HOSTEL_STUDENT_HOSTELS,
  GET_WORKERS_CHART,
  GET_WORKERS_HOSTELS,
  GET_COOKS_CHART,
  GET_COOKS_HOSTELS,
  GET_KAMATI_CHART,
  GET_KAMATI_HOSTELS,
  GET_WATCHMAN_CHART,
  GET_WATCHMAN_HOSTELS,
  GET_AVAILABLE_SCAVENGERS_CHART,
  GET_AVAILABLE_SCAVENGERS_HOSTELS,
  GET_REQUIRED_SCAVENGERS_CHART,
  GET_REQUIRED_SCAVENGERS_HOSTELS,
  GET_LIVING_ROOMS_CHART,
  GET_LIVING_ROOMS_HOSTELS,
  GET_WORKING_FANS_CHART,
  GET_WORKING_FANS_HOSTELS,
  GET_WORKING_TUBELIGHT_CHART,
  GET_WORKING_TUBELIGHT_HOSTELS,
  GET_AVAILABLE_CCTV_CHART,
  GET_AVAILABLE_CCTV_HOSTELS,
  GET_FUNCTIONING_CCTV_CHART,
  GET_FUNCTIONING_CCTV_HOSTELS,
  GET_FEEDBACK_HOSTELS,
  GET_STUDENT_TOP_THREE_CONCERNS,
  GET_PHC_DISTANCE_CHART,
  GET_PHC_DISTANCE_HOSTELS,
  CHART_REPORT,
  DASHBOARD_VARIATION_BAR_CHART,
  DASHBOARD_VARIATION_HOSTELS,
  DASHBOARD_PHOTOS,
  DASHBOARD_METRICS,
  DASHBOARD_METRICS_HOSTELS,
  DASHBOARD_METRICS_MANDALS,
} = API_ROUTES

const getShiftReportApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_SHIFT_REPORT, { params })
  return response?.data
}

const getDiscrepanciesApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_DISCREPANCIES, { params })
  return response?.data
}

const getDrinkingWaterChartApi = async ({ params }) => {
  const response = await getMethod(GET_DRINKING_WATER_BAR_CHART, { params })
  return response?.data
}

const getDrinkingWaterHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_DRINKING_WATER_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getStaffAvailabilityChartApi = async ({ params }) => {
  const response = await getMethod(GET_STAFF_AVAILABILITY_CHART, { params })
  return response?.data
}

const getStaffAvailabilityHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_STAFF_AVAILABILITY_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getPrincipalAuthorityBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_PRINCIPAL_AUTHORITY_BAR_CHART, {
    params,
  })
  return response?.data
}
const getInspectionAssessmentPieChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_INSPECTION_ASSESSMENT_PIE_CHART, {
    params,
  })
  return response?.data
}
const getInspectionAssessmentHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_INSPECTION_ASSESSMENT_HOSTELS({ pageNo }),
    { params },
  )
  return response?.data
}

const getAvailableToiletsChartApi = async ({ params }) => {
  const response = await getMethod(GET_AVAILABLE_TOILETS_CHART, { params })
  return response?.data
}

const getAvailableToiletsHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_AVAILABLE_TOILETS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getPrincipalAuthorityHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_PRINCIPAL_AUTHORITY_HOSTELS({
      params: apiParams({ params, pageNo }),
    }),
  )
  return response?.data
}

const getRecordMaintenanceBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_RECORD_MAINTENANCE_BAR_CHART, {
    params,
  })
  return response?.data
}

const getOverallHostelConditionBarChartApi = async ({ params }) => {
  const response = await getMethod(
    DASHBOARD_OVERALL_HOSTEL_CONDITION_BAR_CHART,
    {
      params,
    },
  )
  return response?.data
}

const getOverallHostelConditionHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_OVERALL_HOSTEL_CONDITION_HOSTELS({ pageNo }),
    { params },
  )
  return response?.data
}

const getRecordMaintenanceHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_RECORD_MAINTENANCE_HOSTELS({
      params: apiParams({ params, pageNo }),
    }),
  )
  return response?.data
}

const getWasteManagementBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_WASTE_MANAGEMENT_BAR_CHART, {
    params,
  })
  return response?.data
}

const getWasteManagementHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_WASTE_MANAGEMENT_HOSTELS({
      params: apiParams({ params, pageNo }),
    }),
  )
  return response?.data
}

const getToiletsSufficiencyBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_TOILETS_SUFFICIENCY_BAR_CHART, {
    params,
  })
  return response?.data
}

const getToiletsSufficiencyHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_TOILETS_SUFFICIENCY_HOSTELS({
      params: apiParams({ params, pageNo }),
    }),
  )
  return response?.data
}

const getLocationBedsMattressesBarChartApi = async ({ params }) => {
  const response = await getMethod(
    DASHBOARD_LOCATION_BEDS_MATTRESSES_BAR_CHART,
    {
      params,
    },
  )
  return response?.data
}

const getFunctioningToiletsChartApi = async ({ params }) => {
  const response = await getMethod(GET_FUNCTIONING_TOILETS_CHART, { params })
  return response?.data
}

const getFunctioningToiletsHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(
    GET_FUNCTIONING_TOILETS_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getLocationBedsMattressesHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_LOCATION_BEDS_MATTRESSES_HOSTELS({
      params: apiParams({ params, pageNo }),
    }),
  )
  return response?.data
}

const getMedicalCareBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_MEDICAL_CARE_BAR_CHART, {
    params,
  })
  return response?.data
}

const getMedicalCareHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(DASHBOARD_MEDICAL_CARE_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getPHCDistanceChartApi = async ({ params }) => {
  const response = await getMethod(GET_PHC_DISTANCE_CHART, {
    params,
  })
  return response?.data
}

const getPHCDistanceHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(GET_PHC_DISTANCE_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getEducationFacilitiesBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_EDUCATION_FACILITIES_BAR_CHART, {
    params,
  })
  return response?.data
}

const getEducationFacilitiesHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_EDUCATION_FACILITIES_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getHostelStudentsChartApi = async ({ params }) => {
  const response = await getMethod(GET_HOSTEL_STUDENT_CHART, { params })
  return response?.data
}

const getStudentsHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_HOSTEL_STUDENT_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getWorkersChartApi = async ({ params }) => {
  const response = await getMethod(GET_WORKERS_CHART, { params })
  return response?.data
}
const getWorkersHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_WORKERS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getCooksChartApi = async ({ params }) => {
  const response = await getMethod(GET_COOKS_CHART, { params })
  return response?.data
}
const getCooksHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_COOKS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getKamatiChartApi = async ({ params }) => {
  const response = await getMethod(GET_KAMATI_CHART, { params })
  return response?.data
}
const getKamatiHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_KAMATI_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getWatchmanChartApi = async ({ params }) => {
  const response = await getMethod(GET_WATCHMAN_CHART, { params })
  return response?.data
}
const getWatchmanHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_WATCHMAN_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getAvailableScavengersChartApi = async ({ params }) => {
  const response = await getMethod(GET_AVAILABLE_SCAVENGERS_CHART, { params })
  return response?.data
}
const getAvailableScavengersHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(
    GET_AVAILABLE_SCAVENGERS_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}
const getRequiredScavengersChartApi = async ({ params }) => {
  const response = await getMethod(GET_REQUIRED_SCAVENGERS_CHART, { params })
  return response?.data
}
const getRequiredScavengersHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(
    GET_REQUIRED_SCAVENGERS_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getFoodProvisionsBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_FOOD_PROVISIONS_BAR_CHART, {
    params,
  })
  return response?.data
}

const getFoodProvisionsHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_FOOD_PROVISIONS_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getVariationBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_VARIATION_BAR_CHART, {
    params,
  })
  return response?.data
}

const getVariationHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(DASHBOARD_VARIATION_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getPrecautionaryMeasuresBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_PRECAUTIONARY_MEASURES_BAR_CHART, {
    params,
  })
  return response?.data
}

const getPrecautionaryMeasuresHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_PRECAUTIONARY_MEASURES_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getAnimalThreatBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_ANIMAL_THREAT_BAR_CHART, {
    params,
  })
  return response?.data
}

const getAnimalThreatHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_ANIMAL_THREAT_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getConductionMeetingsBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_CONDUCTION_MEETINGS_BAR_CHART, {
    params,
  })
  return response?.data
}

const getConductionMeetingsHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(
    DASHBOARD_CONDUCTION_MEETINGS_HOSTELS({ pageNo }),
    {
      params,
    },
  )
  return response?.data
}

const getCookingFuelBarChartApi = async ({ params }) => {
  const response = await getMethod(DASHBOARD_COOKING_FUEL_BAR_CHART, {
    params,
  })
  return response?.data
}

const getCookingFuelHostelsApi = async ({ params, pageNo = 1 }) => {
  const response = await getMethod(DASHBOARD_COOKING_FUEL_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getLivingRoomsChartApi = async ({ params }) => {
  const response = await getMethod(GET_LIVING_ROOMS_CHART, { params })
  return response?.data
}
const getLivingRoomsHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_LIVING_ROOMS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getTubelightChartApi = async ({ params }) => {
  const response = await getMethod(GET_WORKING_TUBELIGHT_CHART, { params })
  return response?.data
}
const getTubelightHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_WORKING_TUBELIGHT_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getFansChartApi = async ({ params }) => {
  const response = await getMethod(GET_WORKING_FANS_CHART, { params })
  return response?.data
}
const getFansHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_WORKING_FANS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getAvailableCCTVChartApi = async ({ params }) => {
  const response = await getMethod(GET_AVAILABLE_CCTV_CHART, { params })
  return response?.data
}
const getAvailableCCTVHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_AVAILABLE_CCTV_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getFunctioningCCTVChartApi = async ({ params }) => {
  const response = await getMethod(GET_FUNCTIONING_CCTV_CHART, { params })
  return response?.data
}
const getFunctioningCCTVHostelsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_FUNCTIONING_CCTV_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}
const getFeedbackHostelsApi = async ({ pageNo, params }) => {
  // const response = await getMethod(GET_FEEDBACK_HOSTELS({ pageNo }), {
  //   params,
  // })
  const response = await getMethod(GET_FEEDBACK_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getStudentTopThreeConcernsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_STUDENT_TOP_THREE_CONCERNS({ pageNo }), {
    params,
  })
  return response?.data
}

const getChartReportApi = async ({ payload }) => {
  const response = await postMethod(CHART_REPORT, payload)
  return response?.data
}

const getDashboardPhotosApi = async ({ pageNo, params }) => {
  const response = await getMethod(DASHBOARD_PHOTOS({ pageNo }), {
    params,
  })
  return response?.data
}

const getDashboardMetricsApi = async () => {
  const response = await getMethod(DASHBOARD_METRICS)
  return response?.data
}

const getDashboardMetricsHostelsApi = async ({ pageNo = 1, params }) => {
  const response = await getMethod(DASHBOARD_METRICS_HOSTELS({ pageNo }), {
    params,
  })
  return response?.data
}

const getDashboardMetricsMandalsApi = async ({ pageNo = 1, params }) => {
  const response = await getMethod(DASHBOARD_METRICS_MANDALS({ pageNo }), {
    params,
  })
  return response?.data
}

export {
  getDiscrepanciesApi,
  getShiftReportApi,
  getPrincipalAuthorityBarChartApi,
  getInspectionAssessmentPieChartApi,
  getInspectionAssessmentHostelsApi,
  getPrincipalAuthorityHostelsApi,
  getDrinkingWaterChartApi,
  getDrinkingWaterHostelsApi,
  getAvailableToiletsChartApi,
  getAvailableToiletsHostelsApi,
  getStaffAvailabilityChartApi,
  getStaffAvailabilityHostelsApi,
  getRecordMaintenanceBarChartApi,
  getOverallHostelConditionBarChartApi,
  getOverallHostelConditionHostelsApi,
  getRecordMaintenanceHostelsApi,
  getWasteManagementBarChartApi,
  getWasteManagementHostelsApi,
  getToiletsSufficiencyBarChartApi,
  getToiletsSufficiencyHostelsApi,
  getLocationBedsMattressesBarChartApi,
  getLocationBedsMattressesHostelsApi,
  getMedicalCareBarChartApi,
  getMedicalCareHostelsApi,
  getEducationFacilitiesBarChartApi,
  getEducationFacilitiesHostelsApi,
  getFoodProvisionsBarChartApi,
  getFoodProvisionsHostelsApi,
  getPrecautionaryMeasuresBarChartApi,
  getPrecautionaryMeasuresHostelsApi,
  getAnimalThreatBarChartApi,
  getAnimalThreatHostelsApi,
  getConductionMeetingsBarChartApi,
  getConductionMeetingsHostelsApi,
  getCookingFuelBarChartApi,
  getCookingFuelHostelsApi,
  getFunctioningToiletsChartApi,
  getFunctioningToiletsHostelsApi,
  getHostelStudentsChartApi,
  getStudentsHostelsApi,
  getWorkersChartApi,
  getWorkersHostelsApi,
  getCooksChartApi,
  getCooksHostelsApi,
  getKamatiChartApi,
  getKamatiHostelsApi,
  getWatchmanChartApi,
  getWatchmanHostelsApi,
  getAvailableScavengersChartApi,
  getAvailableScavengersHostelsApi,
  getRequiredScavengersChartApi,
  getRequiredScavengersHostelsApi,
  getLivingRoomsChartApi,
  getLivingRoomsHostelsApi,
  getTubelightChartApi,
  getTubelightHostelsApi,
  getFansChartApi,
  getFansHostelsApi,
  getAvailableCCTVChartApi,
  getAvailableCCTVHostelsApi,
  getFunctioningCCTVChartApi,
  getFunctioningCCTVHostelsApi,
  getFeedbackHostelsApi,
  getStudentTopThreeConcernsApi,
  getPHCDistanceChartApi,
  getPHCDistanceHostelsApi,
  getChartReportApi,
  getVariationBarChartApi,
  getVariationHostelsApi,
  getDashboardPhotosApi,
  getDashboardMetricsApi,
  getDashboardMetricsHostelsApi,
  getDashboardMetricsMandalsApi,
}
